<template>
  <div class="pp-toolbar" data-cy="pp-toolbar">
    <div v-if="media.sm">
      <div class="row">
        <div class="col px-4">
          <el-tooltip class="item" effect="dark" content="Búsqueda normal" placement="top">
            <el-input
              v-model="modelQuerySearch"
              @keyup.enter.native="enterQuery"
              @clear="clearQuery"
              size="medium"
              suffix-icon="el-icon-search"
              class="searchFilter"
              placeholder="Buscando..."
              clearable
              label="Buscando..."
              data-cy="searchFilter"/>
          </el-tooltip>
        </div>
      </div>

      <div class="row">
        <div class="col px-4 pt-2">
          <el-tooltip class="item" effect="dark" content="Buscar por rangos de fechas" placement="top">
            <el-date-picker
              type="daterange"
              align="right"
              size="medium"
              class="daterangeFilter"
              start-placeholder="Fecha Inicial"
              end-placeholder="Fecha Final"
              v-model="modelDateFilter"
              :picker-options="pickerOptFilterDate"
              data-cy="daterangeFilter">
            </el-date-picker>
          </el-tooltip>
        </div>
      </div>
      <div class="row">
        <div class="col px-4">
          <div class="d-flex justify-content-center pt-2">
            <el-tooltip effect="dark" content="Refrescar la tabla" placement="top">
              <el-button icon="el-icon-refresh" class="refreshTabla" @click="refreshTabla"
                         :disabled="isLoading"
                         circle data-cy="refreshTabla">
              </el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="Exportar a Excel o Pdf" placement="top">
              <el-button icon="el-icon-share" class="exportToFile" @click="exportToFile"
                         :disabled="isEmptyTableData"
                         circle data-cy="exportToFile">
              </el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="Aprobar selecionadas" placement="top" v-if="isCheckSelection">
              <el-button icon="el-icon-plus" class="check" @click="checkSelection"
                         type="warning"
                         :disabled="isEmptyTableData || unSelect"
                         circle data-cy="check">
              </el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="Aprobar todas" placement="top" v-if="isCheckAll">
              <el-button icon="el-icon-check" class="checkAll" @click="checkAll"
                         type="danger"
                         :disabled="isEmptyTableData"
                         circle data-cy="checkAll">
              </el-button>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-5">
          <div class="ml-4 pt-3">
            <el-tooltip class="item" effect="dark" content="Búsqueda normal" placement="top">
              <el-input
                v-model="modelQuerySearch"
                @keyup.enter.native="enterQuery"
                @clear="clearQuery"
                size="medium"
                suffix-icon="el-icon-search"
                class="searchFilter"
                placeholder="Buscando..."
                clearable
                label="Buscando..."
                data-cy="searchFilter"/>
            </el-tooltip>
          </div>
        </div>
        <div class="col-3 pt-3">
          <el-tooltip class="item" effect="dark" content="Buscar por rangos de fechas" placement="top">
            <el-date-picker
              type="daterange"
              align="right"
              size="medium"
              start-placeholder="Fecha Inicial"
              end-placeholder="Fecha Final"
              v-model="modelDateFilter"
              :picker-options="pickerOptFilterDate"
              class="daterangeFilter"
              data-cy="daterangeFilter">
            </el-date-picker>
          </el-tooltip>
        </div>
        <div class="col-4 ">
          <div class="pt-3 d-flex justify-content-end" data-cy="refresh-button">
            <el-tooltip effect="dark" content="Refrescar la tabla" placement="top">
              <el-button icon="el-icon-refresh" class="refreshTabla" @click="refreshTabla"
                         :disabled="isLoading"
                         circle>
              </el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="Exportar a Excel o Pdf" placement="top">
              <el-button icon="el-icon-share" class="exportToFile" @click="exportToFile"
                         :disabled="isEmptyTableData"
                         circle data-cy="exportToFile">
              </el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="Aprobar selecionadas" placement="top" v-if="isCheckSelection">
              <el-button icon="el-icon-plus" class="check" @click="checkSelection"
                         type="warning"
                         :disabled="isEmptyTableData || unSelect"
                         circle data-cy="check">
              </el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="Aprobar todas" placement="top" v-if="isCheckAll">
              <el-button icon="el-icon-check" class="checkAll" @click="checkAll"
                         type="danger"
                         :disabled="isEmptyTableData"
                         circle data-cy="checkAll">
              </el-button>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {Button, DatePicker, Tooltip} from "element-ui";

export default {
  name: "ToolbarSearch",
  components: {
    [Button.name]: Button,
    [DatePicker.name]: DatePicker,
    [Tooltip.name]: Tooltip,
  },
  mixins: [ScreenSizeMixin],
  props: {
    isEmptyTableData: Boolean,
    isCheckSelection: {
      type: Boolean,
      default: false
    },
    isCheckAll: {
      type: Boolean,
      default: false
    },
    unSelect: {
      type: Boolean,
      default: true
    },
    isLoading: Boolean,
    dateFilter: Array,
    querySearch: String,
  },
  data() {
    return {
      pickerOptFilterDate: {
        shortcuts: [{
          text: 'Última semana',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Último mes',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Últimos 3 meses',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }],
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      }
    }
  },
  computed: {
    modelQuerySearch: {
      get() {
        return this.querySearch
      },
      set(value) {
        this.$emit('on-query-search', value)
      }
    },
    modelDateFilter: {
      get() {
        return this.dateFilter
      },
      set(value) {
        this.$emit('on-date-filter', value)
      }
    },
  },
  methods: {
    refreshTabla() {
      this.$log.debug('Toolbar onRefreshTabla')
      this.modelQuerySearch = ''
      this.modelDateFilter = []
      this.$emit('on-refresh-table')
    },
    exportToFile() {
      this.$log.debug('Toolbar ExportToFile')
      this.$emit('on-export-to-file')
    },
    checkSelection() {
      this.$log.debug('Toolbar checkSelection')
      this.$emit('on-check-selection')
    },
    checkAll() {
      this.$log.debug('Toolbar checkAll')
      this.$emit('on-check-all')
    },
    enterQuery() {
      this.$log.debug('input search enter')
      if (this.querySearch.length > 0) {
        this.$emit('on-key-enter', this.querySearch)
      }
    },
    clearQuery() {
      this.$log.debug('input clear search')
      this.$emit('on-refresh-table')
    }
  }
}
</script>
